/** here will add all categories to isolate all hard-coded configs to be in back-end */
export enum ConfigurationCategory {
	chatModule = 'chat-module',
	chatPage = 'chat-page',
}
